export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8680.d74bca39.jpg";